import { Box, Container, Heading, VStack, HStack } from '@chakra-ui/react';
import { Provider } from './components/ui/provider';
import { Toaster } from './components/ui/toaster';
import { ColorModeButton } from './components/ui/color-mode';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ModuleList } from './components/ModuleList';
import { useColorModeValue } from './components/ui/color-mode';

// Create a client
const queryClient = new QueryClient();

function Home() {
  const bgColor = useColorModeValue('white', 'gray.900');
  const textColor = useColorModeValue('gray.900', 'gray.100');
  const subtitleColor = useColorModeValue('gray.600', 'gray.400');

  return (
    <Box minH="100vh" bg={bgColor}>
      <Container maxW="container.xl" py={8}>
        <VStack gap={8} align="stretch">
          <Box>
            <HStack justify="space-between" align="start" mb={4}>
              <Box>
                <Heading as="h1" size="2xl" mb={2} color={textColor}>
                  ACERTUS Terraform Module Registry
                </Heading>
                <Heading as="h2" size="md" color={subtitleColor}>
                  Manage and distribute your Terraform modules
                </Heading>
              </Box>
              <ColorModeButton />
            </HStack>
          </Box>

          <Box>
            <ModuleList />
          </Box>
        </VStack>
      </Container>
    </Box>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Provider>
        <Home />
        <Toaster />
      </Provider>
    </QueryClientProvider>
  );
}

export default App; 